(() => {
class $7b6580275555a38e$var$ConnectedProducts extends HTMLElement {
    constructor(){
        super();
        this._placeholder = this.querySelector('.connected-products-placeholder__subtitle');
        this._originalSubtitleText = '';
        this._originalSubtitleColor = '';
        this._onEnter = this._onEnter.bind(this);
        this._onLeave = this._onLeave.bind(this);
    }
    connectedCallback() {
        if (this._placeholder) {
            this._originalSubtitleText = this._placeholder.textContent || '';
            const computed = window.getComputedStyle(this._placeholder);
            this._originalSubtitleColor = computed.color || '';
        }
        const items = this.querySelectorAll('.connected-product');
        if (!items) return;
        items.forEach((el)=>{
            el.addEventListener('mouseenter', this._onEnter);
            el.addEventListener('mouseleave', this._onLeave);
        });
    }
    disconnectedCallback() {
        const items = this.querySelectorAll('.connected-product');
        if (!items) return;
        items.forEach((el)=>{
            el.removeEventListener('mouseenter', this._onEnter);
            el.removeEventListener('mouseleave', this._onLeave);
        });
    }
    updateSubtitle(color) {
        if (!this._placeholder) return;
        this._placeholder.textContent = color;
    }
    _onEnter(e) {
        const el = e.currentTarget;
        const color = el?.getAttribute('data-product-color') || '';
        if (color) this.updateSubtitle(color);
    }
    _onLeave() {
        this.updateSubtitle(this._originalSubtitleText);
    }
}
if (!customElements.get('connected-products')) customElements.define('connected-products', $7b6580275555a38e$var$ConnectedProducts);


document.addEventListener('DOMContentLoaded', function() {
    if (!window.FoxTheme || !window.FoxTheme.Carousel) return;
    document.querySelectorAll('.product-swiper').forEach(function(el) {
        if (el.__initialized) return;
        el.__initialized = true;
        const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 8,
            loop: false,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev')
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets'
            }
        };
        const instance = new window.FoxTheme.Carousel(el, swiperOptions);
        instance.init();
    });
});


document.addEventListener('DOMContentLoaded', ()=>{
    const wrapper = document.querySelector('ooo-wl-product-page-button');
    const iconsList = document.querySelector('.wishlist-block');
    if (!iconsList) return;
    const wishListOn = iconsList.getAttribute('data-true-wishlist');
    const wishListOff = iconsList.getAttribute('data-false-wishlist');
    if (!wishListOn || !wishListOff) return;
    const icon_1 = JSON.parse(wishListOn);
    const icon_2 = JSON.parse(wishListOff);
    if (!wrapper || !wrapper.shadowRoot) return;
    const btn = wrapper.shadowRoot.querySelector('button.button--fill');
    if (!btn) return;
    function createIcon(iconUrl) {
        const img = document.createElement('img');
        img.src = iconUrl;
        img.style.width = '26px';
        img.style.height = '26px';
        img.style.display = 'block';
        img.classList.add('ooo-wl-button-icon', 'ooo-wl-button-icon--custom');
        return img;
    }
    function updateIcon() {
        const isWishlisted = btn.getAttribute('aria-checked') === 'true';
        const existingIcon = btn.querySelector('img.ooo-wl-button-icon--custom');
        if (existingIcon) existingIcon.remove();
        const newIcon = createIcon(isWishlisted ? icon_1 : icon_2);
        btn.insertBefore(newIcon, btn.firstChild);
    }
    updateIcon();
    // Watch for changes to aria-checked attribute
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-checked') updateIcon();
        });
    });
    observer.observe(btn, {
        attributes: true
    });
});



})();
//# sourceMappingURL=parcel_scripts.js.map
